import { Pipe, PipeTransform } from '@angular/core';
import { StatusSprawy } from '@interfaces/stypendia/sprawy/sprawy-studentow/status-sprawy.enum';

@Pipe({
  name: 'statusSprawyStypendia',
})
export class StatusSprawyStypendiaPipe implements PipeTransform {
  transform(value: StatusSprawy): string {
    const {
      WTrakcieWeryfikacji,
      OczekujeNaRozpatrzenie,
      WTrakcieRozpatrywania,
      OczekujeNaWydanieDecyzji,
      OczekujeNaPodpisPostanowienia: OczekujeNaPodpisPostanowienia,
      OczekujeNaPotwierdzenieOtrzymaniaPostanowienia: OczekujeNaPotwierdzenieOtrzymaniaPostanowieniaOOdmowieWszczecia,
      DoUmorzenia,
      OczekujeNaPodpisDecyzjiOUmorzeniuPostepowania: OczekujeNaPodpisDecyzjiOUmorzeniuPostepowania,
      OczekujeNaPotwierdzenieOtrzymaniaDecyzjiOUmorzeniuPostepowania,
      WTrakcieWeryfikacjiPoZawiadomieniu,
      WszczetoPostepowanieStwierdzonoBrakiFormalne,
      SprawaZamknietaWycofanoPodanie,
      WPrzygotowaniuDoDrugiejInstancji,
      RozpatrywanieOdwolania,
      OczekujeNaWydanieDecyzjiOdwolanie,
      WPrzygotowaniuDecyzjiZmieniajacej,
      OczekujeNaWydanieDecyzjiZmieniajacej,
      Zarchiwizowano,
      DecyzjaOPonowneRozpatrzenieWPrzygotowaniu,
      OczekujeNaWydanieDecyzjiOPonowneRozpatrzenie,
      WygenerowanoSzablonDecyzjiZmieniajacej,
      SprawaZostawionaBezRozpoznania: PozostawionoBezRozpoznania,
      Nowa,
      Przydzielono,
      WydanoDecyzje,
      DoreczonoDecyzje,
      UprawomocnionoDecyzje,
      WygenerowanoSzablonPostanowienia: WygenerowanoSzablonPostanowienia,
      WydanoPostanowienie: WydanoPostanowienie,
      DoreczonoPostanowienie: DoreczonoPostanowienieOOdmowieWszczecia,
      WydanoDecyzjeOUmorzeniuPostepowania,
      DoreczonoDecyzjeOUmorzeniuPostepowania,
      UprawomocnionoDecyzjeOUmorzeniuPostepowania,
      PrzydzielonoDoSprawyZUrzeduPracownika,
      ZawiadomienieOWszczeciu: ZawiadomionoOWszczeciu,
      WplyneloOdwolanie,
      PrzekazanoDoDrugiejInstancji,
      WydanoDecyzjeOdwolanie: WydanieDecyzjiOdwolanie,
      DecyzjaDoreczonaOdwolanie,
      DecyzjaPrawomocnaOdwolanie,
      WydanoDecyzjeZmieniajaca,
      DoreczonoDecyzjeZmieniajaca,
      UprawomocnionoDecyzjeZmieniajaca,
      WplynalWniosekOPonowneRozpatrzenie,
      WydanoDecyzjeOPonowneRozpatrzenie,
      DecyzjaOPonowneRozpatrzenieDoreczona,
      DecyzjaOPonowneRozpatrzeniePrawomocna,
    } = StatusSprawy;

    switch (value) {
      case Nowa:
      case Przydzielono:
      case WydanoDecyzje:
      case DoreczonoDecyzje:
      case UprawomocnionoDecyzje:
      case WygenerowanoSzablonPostanowienia:
      case WydanoPostanowienie:
      case DoreczonoPostanowienieOOdmowieWszczecia:
      case WydanoDecyzjeOUmorzeniuPostepowania:
      case DoreczonoDecyzjeOUmorzeniuPostepowania:
      case UprawomocnionoDecyzjeOUmorzeniuPostepowania:
      case PrzydzielonoDoSprawyZUrzeduPracownika:
      case ZawiadomionoOWszczeciu:
      case WplyneloOdwolanie:
      case PrzekazanoDoDrugiejInstancji:
      case WydanieDecyzjiOdwolanie:
      case DecyzjaDoreczonaOdwolanie:
      case DecyzjaPrawomocnaOdwolanie:
      case WydanoDecyzjeZmieniajaca:
      case DoreczonoDecyzjeZmieniajaca:
      case UprawomocnionoDecyzjeZmieniajaca:
      case WplynalWniosekOPonowneRozpatrzenie:
      case WydanoDecyzjeOPonowneRozpatrzenie:
      case DecyzjaOPonowneRozpatrzenieDoreczona:
      case DecyzjaOPonowneRozpatrzeniePrawomocna:
        return 'bg-success';
      case WTrakcieWeryfikacji:
      case WTrakcieRozpatrywania:
      case OczekujeNaRozpatrzenie:
      case OczekujeNaWydanieDecyzji:
      case OczekujeNaPodpisPostanowienia:
      case OczekujeNaPotwierdzenieOtrzymaniaPostanowieniaOOdmowieWszczecia:
      case OczekujeNaPodpisDecyzjiOUmorzeniuPostepowania:
      case OczekujeNaPotwierdzenieOtrzymaniaDecyzjiOUmorzeniuPostepowania:
      case WTrakcieWeryfikacjiPoZawiadomieniu:
      case WszczetoPostepowanieStwierdzonoBrakiFormalne:
      case WPrzygotowaniuDoDrugiejInstancji:
      case RozpatrywanieOdwolania:
      case OczekujeNaWydanieDecyzjiOdwolanie:
      case WPrzygotowaniuDecyzjiZmieniajacej:
      case OczekujeNaWydanieDecyzjiZmieniajacej:
      case Zarchiwizowano:
      case DecyzjaOPonowneRozpatrzenieWPrzygotowaniu:
      case OczekujeNaWydanieDecyzjiOPonowneRozpatrzenie:
      case WygenerowanoSzablonDecyzjiZmieniajacej:
        return 'bg-warning text-secondary';
      case DoUmorzenia:
      case SprawaZamknietaWycofanoPodanie:
      case PozostawionoBezRozpoznania:
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }
}
